module.exports = __webpack_public_path__ + "static/img/peopleGame4.53b51da.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/peopleGame4.png
// module id = mg4H
// module chunks = 3